import React from "react";
import ofqualLogo from "./images/Ofqual_logo.svg";
import { makeStyles, Theme, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ofqualLogo: {
      pointerEvents: "none",
      filter: "invert(1)",

      display: "block",
      height: "30px",
    },
  })
);

export const OfqualLogo = () => {
  const classes = useStyles();
  return (
    <a
      href="https://www.gov.uk/government/organisations/ofqual"
      target="_blank"
      rel="noopener noreferrer"
    >
      <object
        type="image/svg+xml"
        data={ofqualLogo}
        height="44"
        className={classes.ofqualLogo}
        aria-label="Ofqual logo"
      ></object>
    </a>
  );
};
